export var NotExistError = new Error('Entity not exist');
//# sourceMappingURL=errors.js.map